import React from "react";
import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AlertMessage = ({ title ="Alert Message", open, setOpen, message }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "90%",
            maxWidth: 900,
            maxHeight: "90vh",
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 3,
            outline: "none",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="modal-header"
            style={{
              background: "red",
              color: "white",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              borderBottom: "1px solid #ddd",
            }}
          >
            <Typography variant="h5" style={{ alignSelf: "center" }}>
              {title} 
            </Typography>
            <IconButton
              onClick={handleClose}
              sx={{ color: "white" }}
              data-log="Close Icon Button"
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <div
            className="modal-body"
            style={{ padding: "16px", overflowY: "auto", flexGrow: 1 }}
          >
            <Typography id="modal-title" variant="h6" component="h2">
              {message}
            </Typography>
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "16px",
              borderTop: "1px solid #ddd",
            }}
          >
            <Button
              variant="contained"
              color="error"
              onClick={handleClose}
              style={{ marginLeft: "8px" }}
            >
              OK
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default AlertMessage;
